import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom'; // Import useLocation
import Box from '@mui/material/Box';
import Navbar from '../Navbar';
import HelpAndSupportModal from '../../components/HelpAndSupportModal';
import SettingsModal from '../../components/SettingsModal';
import { useNavbar } from '../../context/NavbarContext'; // Import useNavbar
import { ROUTES } from '../../config/constants'; // Import ROUTES

const Layout = () => {
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false); // Corrected state variable name
  const [darkMode, setDarkMode] = useState(false);
  const { showNavbar, setShowNavbar, sidebarExpanded } = useNavbar(); // Get showNavbar, setShowNavbar, and sidebarExpanded from context
  const location = useLocation(); // Get current location

  const navbarHeight = '64px';
  const sidebarWidthExpanded = '240px';
  const sidebarWidthCollapsed = '64px';

  // Effect to update navbar visibility based on route
  // useEffect(() => {
  //   if (location.pathname === ROUTES.USER_PROFILE_COMPLETION) {
  //     setShowNavbar(false);
  //   } else {
  //     setShowNavbar(true);
  //   }
  // }, [location.pathname, setShowNavbar]);

  // Effect to listen for changes to the 'dark-mode' class on the body
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const isDark = document.body.classList.contains('dark-mode');
      setDarkMode(isDark);
    });

    // Observe changes to the 'class' attribute of the body element
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Initial check
    setDarkMode(document.body.classList.contains('dark-mode'));

    // Cleanup observer on component unmount
    return () => observer.disconnect();
  }, []); // Empty dependency array means this runs once on mount

  const toggleDarkMode = () => {
    setDarkMode(prev => {
      const newDarkMode = !prev;
      if (newDarkMode) {
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
      }
      return newDarkMode;
    });
  };

  const handleOpenHelpModal = () => {
    setIsHelpModalOpen(true);
  };

  const handleCloseHelpModal = () => {
    setIsHelpModalOpen(false);
  };

  const handleOpenSettingsModal = () => {
    setIsSettingsModalOpen(true);
  };

  const handleCloseSettingsModal = () => {
    setIsSettingsModalOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {/* Navbar/Sidebar - conditionally rendered */}
      {showNavbar && (
        <Navbar
          onHelpClick={handleOpenHelpModal}
          onSettingsClick={handleOpenSettingsModal}
          darkMode={darkMode}
        />
      )}
      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // Mobile (< 1024px): margin top for header, no left margin
          marginTop: { xs: showNavbar ? navbarHeight : '0px', lg: '0px' },
          // Desktop (>= 1024px): margin left for sidebar, no top margin
          marginLeft: { xs: '0px', lg: showNavbar ? (sidebarExpanded ? sidebarWidthExpanded : sidebarWidthCollapsed) : '0px' },
          width: {
            xs: '100%',
            lg: showNavbar ? `calc(100% - ${sidebarExpanded ? sidebarWidthExpanded : sidebarWidthCollapsed})` : '100%'
          },
          height: { xs: showNavbar ? `calc(100vh - ${navbarHeight})` : '100vh', lg: '100vh' },
          overflowY: 'auto',
          overflowX: 'hidden',
          transition: 'all 0.3s ease-in-out',
          position: 'relative',
        }}
      >
        <Outlet />
      </Box>

      {/* Help and Support Modal */}
      <HelpAndSupportModal
        open={isHelpModalOpen}
        handleClose={handleCloseHelpModal}
        darkMode={darkMode} // Pass the darkMode state
      />

      {/* Settings Modal */}
      <SettingsModal
        open={isSettingsModalOpen}
        handleClose={handleCloseSettingsModal}
        darkMode={darkMode} // Pass darkMode state
        toggleDarkMode={toggleDarkMode} // Pass toggleDarkMode function
      />
    </Box>
  );
};

export default Layout;